export enum ItemType {
    Crawled = 1,
    Manual = 2,
    Edited = 3,
}
